import React from 'react';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Stack, Typography } from '@mui/material';
import { t } from 'i18next';

export const NoMatch: React.FC = () => {
  return (
    <Stack spacing={2} alignItems="center">
      <WarningAmberIcon
        sx={{
          fontSize: 70,
        }}
      />
      <Typography variant="h4" textAlign={'center'}>
        {t('somethingWentWrong')}
      </Typography>
    </Stack>
  );
};
